var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreviousCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 48,
    viewBox: "0 0 66 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 64,
    height: 46,
    rx: 23,
    stroke: "#2F1C0A",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2921 15.4956C23.9456 14.3937 24.3028 13.1475 24.47 12H26.1494C25.9746 13.4058 25.549 14.9713 24.7131 16.3695C24.1584 17.2966 23.4365 18.1477 22.5094 18.824H41.6516C42.328 18.824 42.9739 18.9304 43.597 19.0976C44.6153 19.3788 45.5424 19.8651 46.3327 20.5186C47.9589 21.8713 49 23.9079 49 26.18C49 28.4521 47.9589 30.4887 46.3327 31.8414C45.0636 32.8976 43.4298 33.5284 41.6516 33.5284H26.3242V31.8414H41.6516C44.7749 31.8414 47.313 29.3033 47.313 26.18C47.313 23.0568 44.7749 20.5186 41.6516 20.5186H22.5474C23.4213 21.1798 24.128 21.9853 24.6903 22.8592C25.5794 24.2498 26.0886 25.8 26.3469 27.1907H24.6447C24.4016 26.066 23.9836 24.8502 23.2921 23.7787C22.1218 21.9397 20.184 20.473 17 20.473V18.786C20.3284 18.786 22.2206 17.3042 23.2921 15.5032V15.4956Z",
    fill: "#2F1C0A",
    stroke: "#2F1C0A",
    strokeWidth: 0.32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousCard);
export default __webpack_public_path__ + "static/media/previous-card.a338bc756b4ffe837d342f68ab206e38.svg";
export { ForwardRef as ReactComponent };